import { Point } from './Point';
import { Size } from './Size';
var Rect = /** @class */ (function () {
    function Rect(point, size) {
        this.point = point;
        this.size = size;
    }
    Rect.prototype.resize = function (w, h) {
        this.size = new Size(w, h);
    };
    Rect.prototype.move = function (x, y) {
        this.point = new Point(x, y);
    };
    return Rect;
}());
export { Rect };
